import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-thank-you-submission",
  templateUrl: "./thank-you-submission.component.html",
  styleUrls: ["./thank-you-submission.component.scss"],
  standalone: false,
})
export class ThankYouSubmissionComponent {
  constructor(private router: Router) {}

  goToDrLanding() {
    this.router.navigate(["/dr-request"]);
  }
}

